<template>
  <ion-row>
    <ion-col size-md="12" size-lg="12">
      <ion-row>
        <ion-col size="2">
          <PersonalizeProgress :current-step="3" :total-steps="4" />
        </ion-col>
        <ion-col size="10">
          <h3 class="h3 text-color-body">{{ t('personalize.purposeTitle') }}</h3>
        </ion-col>
      </ion-row>
      <p class="text-color-body text-align-left text-sm">
        {{ t('personalize.purposeDescription') }}
      </p>
      <div class="mt-lg">
        <ion-radio-group
          v-model="personalizeForm.purpose"
          value="custom-checked"
          class="d-flex flex-column gap-xs"
        >
          <ion-radio
            v-for="option in options"
            :value="option.value"
            :key="`option-${option.value}`"
            class="custom-radio"
            >{{ option.title }}
          </ion-radio>
        </ion-radio-group>
      </div>
    </ion-col>
  </ion-row>
</template>
<script setup lang="ts">
  import { IonCol, IonRow, IonRadioGroup, IonRadio } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { usePersonalize } from '@/composables/usePersonalize';
  import PersonalizeProgress from '@/components/personalize/PersonalizeProgress.vue';
  import { ref } from 'vue';

  const { t } = useI18n();
  const { personalizeForm } = usePersonalize();

  const options = ref([
    { title: t('personalize.placeholders.purpose.options.student'), value: 'student' },
    { title: t('personalize.placeholders.purpose.options.work'), value: 'professional' },
    { title: t('personalize.placeholders.purpose.options.Leisure'), value: 'leisure' },
    { title: t('personalize.placeholders.purpose.options.other'), value: 'other' },
  ]);
</script>
<style scoped lang="scss">
  .custom-radio {
    color: black;
    width: fit-content;
  }
  .radio-wrapper {
    flex-direction: row-reverse !important;
  }
</style>
